import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=6b25621a&scoped=true&"
import script from "./message-detail.vue?vue&type=script&lang=js&"
export * from "./message-detail.vue?vue&type=script&lang=js&"
import style0 from "./message-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./message-detail.vue?vue&type=style&index=1&id=6b25621a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25621a",
  null
  
)

export default component.exports